module.exports = __webpack_public_path__ + "static/media/nonScan.25b5ddb2.png";